/**
 * Geräte-ID – unterscheidet die Geräte eines Nutzers beim Synchronisieren
 * (z. B. getrennte Zeichenzähler). Wird einmal erzeugt und bleibt lokal.
 */

const STORAGE_KEY = 'the-reader-device-id';

let deviceId = null;

/**
 * Liefert die ID dieses Geräts und legt sie beim ersten Aufruf an
 * @returns {string}
 */
export function getDeviceId() {
  if (deviceId) return deviceId;

  try {
    deviceId = localStorage.getItem(STORAGE_KEY);
  } catch {
    // localStorage nicht verfügbar – ID gilt dann nur für diese Sitzung
  }

  if (!deviceId) {
    deviceId = crypto.randomUUID();
    try {
      localStorage.setItem(STORAGE_KEY, deviceId);
    } catch {
      // siehe oben
    }
  }
  return deviceId;
}
